export default __webpack_public_path__ + "static/media/arrow-up.e288b803.svg";